import { useApps } from '@yulintu/freesia-bootstrap';
import React, { useState, useEffect } from 'react';
import { Result, Button, Spin } from 'antd';
import { useParams } from 'react-router-dom';

export default function ToTarget(props) {
    const { apps, busy } = useApps();
    console.log(apps, busy);
    const { key } = useParams();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (busy) {
            return;
        }
        // 从路由参数中获取key
        const target = key;

        if (target) {
            // 查找对应key的应用
            const app = apps.find(item => item.key === target || item.code === target);

            if (app) {
                // 构建完整URL，包含urlParams
                let url = app.url.trim();
                if (app.urlParams) {
                    const params = new URLSearchParams(app.urlParams);
                    const separator = url.includes('?') ? '&' : '?';
                    url += separator + params.toString();
                }
                // 重定向
                window.location.href = url;
            } else {
                // 提示不存在的应用
                setError('不存在的应用');
                setLoading(false);
            }
        } else {
            // 没有target参数
            setError('缺少target参数');
            setLoading(false);
        }
    }, [apps, key, busy]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Spin size="large" tip="正在跳转..." />
            </div>
        );
    }

    return (
        <div style={{ padding: '40px' }}>
            <Result
                status="error"
                title={error}
                subTitle="请检查URL参数是否正确"
                extra={[
                    <Button key="back" type="primary" onClick={() => window.history.back()}>
                        返回
                    </Button>
                ]}
            />
        </div>
    );
}